import "../styles/EnterCode.scss";
import {useLocation, useNavigate} from "react-router-dom";
import {getArtistFromPath} from "../utils/artist.utils";
import {FormCode} from "../services/code";
import {BackButton, Background, LanguageSelector} from "../components";
import {path} from "../router/path";

const EnterCode = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const artist = getArtistFromPath(location.pathname);

  const handleBack = () => {
    navigate(path.waiting(artist));
  };

  const handleExpire = () => {
    navigate(path.waiting(artist));
  };

  return (
    <div className="enter-code-container">
      <Background artist={artist} />
      <div className="enter-code-header">
        <BackButton artist={artist} onClick={handleBack} />
        <LanguageSelector artist={artist} />
      </div>
      <div className="enter-code-content">
        <FormCode artist={artist} onExpire={handleExpire} />
      </div>
    </div>
  );
};

export default EnterCode;
